import Api from './api.service';

export default {
  getCepInfo: (cep = '') => Api.get(`address/cep-info`, { params: { cep } }),
};
